<template>
  <div class="container">
    <div class="text-end p-3">
      <c-primary-button to="/admin/configuraciones/frecuencias/crear">
        Crear frecuencia
      </c-primary-button>
    </div>
    <c-card title="Frecuencias">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Frecuencia</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="frequency in frequencies" :key="frequency.id">
            <td>{{ frequency.frecuency }}</td>
            <td class="text-nowrap">
              <router-link
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                :to="`/admin/configuraciones/frecuencias/${frequency.id}/editar`"
                title="Editar"
                ><i class="fa-solid fa-pen"></i
              ></router-link>
              <a
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                href="javascript:void(0)"
                @click="deleteFrequency(frequency.id)"
                title="Eliminar"
                ><i class="fa-solid fa-trash-can"></i
              ></a>
            </td>
          </tr>
        </tbody>
      </table>
    </c-card>
  </div>
</template>
<script>
import CCard from "@/components/CCard.vue";
import CPrimaryButton from "@/components/CPrimaryButton.vue";
import { all, remove } from "@/services/frequencies";
import { showNotification } from "@/services/notification";

export default {
  components: {
    CCard,
    CPrimaryButton,
  },
  data() {
    return {
      frequencies: [],
    };
  },
  mounted() {
    this.getFrequencies();
  },
  methods: {
    getFrequencies() {
      all()
        .then((response) => {
          this.frequencies = response.data;
        })
        .catch(() => {
          alert("No pudimos cargar las frecuencias");
        });
    },
    deleteFrequency(id) {
      const removeRecord = confirm("¿Estás seguro de eliminar el registro?");
      if (!removeRecord) {
        return;
      }
      remove(id).then(() => {
        showNotification(204, "success", "El registro fue eliminado.");
        this.getFrequencies();
      });
    },
  },
};
</script>
